<template>
  <div class="hide-desktop">
    <div class="taller">

    </div>
    <div class="tabbar">
      <ChatBoxTitle>
        <div slot="left">
          <img class="hide-desktop" src="../img/heart-white.svg" @click="$emit('bar', 'favourite')" alt="Add Favourite room" title="Add Favourite room">
          <!-- <img class="" src="../img/qr.svg" style="cursor: pointer;" @click="() => { show = 'qrcode' }" alt="Qr Code"> -->
        </div>
        <div slot="center">
          <img class="hide-desktop" src="../img/search.svg" @click="$emit('bar', 'search')" alt="Search room" title="Search room">
          <!-- <a class="title-link" target="_blank" :href="`https://yoteachapp.com/room/${room._id}`" v-if="room && room.title">{{ room.title }}</a> -->
        </div>
        <div slot="right">
          <img class="hide-desktop" src="../img/create-room.svg" @click="$emit('bar', 'create')" alt="Create room" title="Create room">
          <!-- <img src="../img/qr.svg" style="cursor: pointer;" @click="() => { show = 'qrcode' }" alt="Qr Code"> -->
          <!-- <img src="../img/dot3.svg" @click="show = 'features'" alt="Menu" style="cursor: pointer;"> -->
        </div>
      </ChatBoxTitle>
    </div>
  </div>
</template>

<script>
import ChatBoxTitle from './ChatBoxTitle'
export default {
  components: {
    ChatBoxTitle
  }
}
</script>

<style scoped>
.tabbar{
  position: absolute;
  bottom: -1px;
  left: 0px;
  width: 100%;
}

.taller{
  height: calc(27px + 15px);
}

@media screen and (min-width: 767px) {
  .hide-desktop{
    display: none;
  }
}
</style>
